<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <MarketSegmentRadioFormPart @result="onResult" @change="onChange" />
      <h2 class="form-modal__part-title">
        {{ $t('steps.typeOfAssignment') }}
      </h2>
      <ServiceRadioFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import ServiceRadioFormPart from 'chimera/officeOfNotary/components/form/parts/service/ServiceRadioFormPart'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import MarketSegmentRadioFormPart from 'chimera/all/components/form/parts/marketSegment/MarketSegmentRadioFormPart.vue'
import NextStep from '~/pages/offertes-aanvragen/je-gegevens'

export default {
  name: 'ServiceTypeFormStep',

  components: {
    MarketSegmentRadioFormPart,
    ServiceRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
